import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const createNewReservationTableRequest = async (token, { newTableData }) => {
  const url = apiURl + "reservation/table/create";

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(newTableData),
  };

  return fetchAndReturn(url, parameters);
};

const editReservationTableRequest = async (token, { editTableData }) => {
  const url = apiURl + "reservation/table/edit";

  const parameters = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(editTableData),
  };

  return fetchAndReturn(url, parameters);
};

const deleteReservationTableRequest = async (token, { deteleTableData }) => {
  const url = apiURl + "reservation/table/delete";

  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(deteleTableData),
  };

  return fetchAndReturn(url, parameters);
};

const getReservationTableRequest = async (token, { regionId }) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "reservation/table/getall?organizationId=" +
    organizationId +
    "&regionId=" +
    regionId;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const createNewRegionRequest = async (token, { newRegionData }) => {
  const url = apiURl + "reservation/region/create";

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(newRegionData),
  };

  return fetchAndReturn(url, parameters);
};

const getRegionsRequest = async (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl + "reservation/region/getall?organizationId=" + organizationId;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const editRegionRequest = async (token, { editRegionData }) => {
  const url = apiURl + "reservation/region/edit";

  const parameters = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(editRegionData),
  };

  return fetchAndReturn(url, parameters);
};

const deleteRegionRequest = async (token, { deleteRegionData }) => {
  const url = apiURl + "reservation/region/delete";

  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(deleteRegionData),
  };

  return fetchAndReturn(url, parameters);
};

const getTouchsaleTablesPerRegionRequest = async (
  token,
  { getTouchsaleTablesData }
) => {
  const url =
    apiURl +
    "reservation/table/GetAvailableTables?organizationId=" +
    getTouchsaleTablesData.organizationId +
    "&regionId=" +
    getTouchsaleTablesData.regionId +
    "&restaurantId=" +
    getTouchsaleTablesData.restaurantId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const busyOrFreeTableRequest = async (token, { data }) => {
  const url = apiURl + "reservation/table/setbusy";

  const parameters = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  };
  return fetchAndReturn(url, parameters);
};

export {
  createNewReservationTableRequest,
  editReservationTableRequest,
  getReservationTableRequest,
  deleteReservationTableRequest,
  createNewRegionRequest,
  getRegionsRequest,
  editRegionRequest,
  deleteRegionRequest,
  getTouchsaleTablesPerRegionRequest,
  busyOrFreeTableRequest,
};
